<!-- Offer banner (replica of rushplays.com #offer-banner) -->
<div class="ref-offer-wrap">
<div class="ref-offer-banner">
  <div class="rob-inner">

    <!-- Left: flame + live tag + title -->
    <div class="rob-left">
      <div class="rob-flame-box">
        <span class="rob-flame">🔥</span>
      </div>
      <div class="rob-title-wrap">
        <div class="rob-live-tag">
          <span class="rob-live-dot"></span>
          Live Offer
        </div>
        <div class="rob-title-text">
          {{ isLoggedIn ? 'UPTO 100% BONUS' : 'AVAIL 150% SIGNUP BONUS' }}
        </div>
      </div>
    </div>

    <!-- Center: full description -->
    <div class="rob-center">
      <p class="rob-fulltext">
        {{ isLoggedIn
          ? 'Deposit now to unlock upto 100% bonus on every deposit.'
          : 'Sign up now to claim your 150% signup bonus.' }}
      </p>
    </div>

    <!-- Right: CTA -->
    <div class="rob-right">
      <button #referalButton class="rob-cta" (click)="triggerReferalModal()">
        Claim Bonus
        <svg class="rob-cta-arrow" viewBox="0 0 16 16" fill="none" stroke="currentColor"
             stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 8h10M9 4l4 4-4 4"></path>
        </svg>
      </button>
    </div>

  </div>
</div>
</div>


<div class="bg-game-purple">
  <div *ngIf="testimonialsImages.length > 0" class="mx-auto my-6 md:my-2 px-4 sm:px-6 ">
    <owl-carousel-o [options]="customOptions">
      <ng-template carouselSlide *ngFor="let testimonial of testimonialsImages; let i = index">

        <div
          class="relative mx-1 my-2 rounded-[1.7rem] h-[26vh] sm:h-[34vh] md:h-[34vh] overflow-hidden bg-black border border-[#EAB308]/30 ">

          <img [src]="testimonial.ImageBase64" [alt]="testimonial.Name" class="adjust-image" />

          <div class="absolute inset-0 bg-black/20 md:bg-black/10 z-10"></div>

          <div
            class="absolute left-0 top-0 h-full flex flex-col justify-center px-4 sm:px-6 md:pl-10 z-20 w-full sm:w-[70%] md:w-[60%] lg:w-[45%]">
            <h2
              class="text-[1.5rem] sm:text-2xl md:text-3xl lg:text-[2.5rem] font-bold text-yellow-300 drop-shadow-lg mb-1 sm:mb-2 leading-tight">
              <!-- {{ testimonial.Name }} -->
            </h2>
          </div>


          <div class="absolute bottom-4 left-4 sm:bottom-6 sm:left-6 md:bottom-10 md:left-10 z-20">
            <!-- <button *ngIf="testimonial.Route"
              class="--button bg-[#7de7e5] text-black font-bold py-2 px-4 md:px-6 text-xs sm:text-sm md:text-base rounded-md shadow-lg w-fit hover:scale-105 transition-transform mt-2"
              (click)="onPlayNow(testimonial)">
              Play Now!
            </button> -->
          </div>


        </div>

      </ng-template>
    </owl-carousel-o>
  </div>
  <app-referal-cta #referalCta></app-referal-cta>
</div>

<!-- Login popup (shown when a logged-out user clicks Claim Bonus) -->
<div *ngIf="showLoginModal" class="fixed inset-0 z-[1100]">
  <app-login [isPopup]="true" (closed)="closeLoginModal()"></app-login>
</div>